import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Avatar, Button, Dropdown, Modal} from "antd";
import {faArrowRightFromBracket, faGear, faUser} from "@fortawesome/free-solid-svg-icons";
import React from "react";
import {AccountSettingsModal, SettingsContent} from "../routes/settings/SettingsContent";
import {useAppDispatch, useAppSelector} from "../feature/tools";
import {openAccountSettings} from "../feature/project/appSettingsSlice";
import {useCookies} from "react-cookie";
import {useNavigate} from "react-router-dom";
import {logout} from "../feature/project/userSlice";

export const UserMenu = () => {
    const dispatch = useAppDispatch()
    const user = useAppSelector(state => state.users.currentUser)
    const navigate = useNavigate()
    return (
        <>
            <Dropdown
                trigger={['click']}
                menu={{
                    items: [
                        {
                            key: 'name',
                            label: "Hi, " + user?.name,
                            disabled: true
                        },
                        {
                            type: 'divider'
                        },
                        {
                            key: 'settings',
                            icon: <FontAwesomeIcon icon={faGear}/>,
                            label: 'Settings',
                        },
                        {
                            type: 'divider'
                        },
                        {
                            key: 'logout',
                            label: 'Logout',
                            icon: <FontAwesomeIcon icon={faArrowRightFromBracket}/>,
                            onClick: () => {
                                dispatch(logout())
                                navigate(`/`)
                            }
                        }
                    ],
                    onClick: (item) => {
                        if (item.key === 'settings') {
                            dispatch(openAccountSettings('profile'))
                        }
                    }
                }}
            >
                <Avatar style={{cursor: 'pointer'}} src={user?.avatar ?? undefined} icon={<FontAwesomeIcon icon={faUser}/>}/>
            </Dropdown>
            <AccountSettingsModal />
        </>
    )
}
